import { STAKING_LOCK_DURATION, StakingLockDurationType } from "#/shared/types"

import { bigIntToFloat } from "./numbers"

const LOCK_DURATION_LABEL: Record<StakingLockDurationType, string> = {
  [STAKING_LOCK_DURATION.ONE_WEEK]: "1 Week",
  [STAKING_LOCK_DURATION.TWO_WEEKS]: "2 Weeks",
  [STAKING_LOCK_DURATION.ONE_MONTH]: "1 Month",
  [STAKING_LOCK_DURATION.FOUR_MONTHS]: "4 Months",
}

const MATS_REWARD_MULTIPLIER = 15_000_000

const getLockDurationLabel = (lockDuration: StakingLockDurationType): string =>
  LOCK_DURATION_LABEL[lockDuration]

const getAutomaticReLockLabel = (hasAutomaticReLock: boolean): string =>
  `re-lock ${hasAutomaticReLock ? "ON" : "OFF"}`

const getEstimatedMatsReward = (veBTCAmount: bigint): number =>
  Math.floor(Number(bigIntToFloat(veBTCAmount)) * MATS_REWARD_MULTIPLIER)

export default {
  getLockDurationLabel,
  getAutomaticReLockLabel,
  getEstimatedMatsReward,
}
